import { render, staticRenderFns } from "./RecordTag.vue?vue&type=template&id=31f91d08&"
import script from "./RecordTag.vue?vue&type=script&lang=js&"
export * from "./RecordTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports